import React, { createContext, useEffect, useReducer } from "react";
import {
  APP_DEFAULT_VALUE,
  AppContextActions,
  AppContextReducer,
} from "../reducers/app-context-reducer";
import { injectIntl } from "react-intl";
import {
  APP_TOAST_TYPES,
  TOP_NAVIGATION_BACKGROUND_TYPES,
} from "../constants/app-toast-types";
import { SoundManager } from "../audio/sound-manager";

export const AppContext = createContext();

export const AppContextProvider = (props) => {
  const [appState, dispatchApp] = useReducer(
    AppContextReducer,
    APP_DEFAULT_VALUE
  );

  const formatMessage = (id, options) => {
    return props.intl.formatMessage({ id: id }, options);
  };

  const updateTitle = (title) => {
    dispatchApp({ type: AppContextActions.UPDATE_TITLE, value: title });
  };

  const openHelp = () => {
    dispatchApp({ type: AppContextActions.OPEN_HELP_OPTIONS });
  };

  const closeHelp = () => {
    dispatchApp({ type: AppContextActions.CLOSE_HELP_OPTIONS });
  };

  const updateHelpOptionsList = (option, pageTitle) => {
    dispatchApp({
      type: AppContextActions.UPDATE_HELP_OPTIONS_LIST,
      value: option,
    });
    dispatchApp({
      type: AppContextActions.UPDATE_PAGE_TITLE,
      value: pageTitle,
    });
  };

  const clearHelpOptionsList = () => {
    dispatchApp({ type: AppContextActions.CLEAR_HELP_OPTIONS_LIST });
    dispatchApp({ type: AppContextActions.UPDATE_PAGE_TITLE, value: "" });
  };

  const onBackPressed = () => {
    dispatchApp({ type: AppContextActions.BACK_PRESSED });
  };

  const openBackOptions = () => {
    dispatchApp({ type: AppContextActions.OPEN_BACK_OPTIONS });
  };

  const closeBackOptions = () => {
    dispatchApp({ type: AppContextActions.CLOSE_BACK_OPTIONS });
  };

  const showLoader = () => {
    dispatchApp({ type: AppContextActions.SHOW_LOADER });
  };

  const hideLoader = () => {
    dispatchApp({ type: AppContextActions.HIDE_LOADER });
  };

  const showSuccessAlert = (message, destination) => {
    dispatchApp({
      type: AppContextActions.SHOW_SUCCESS_ALERT,
      value: { message, destination },
    });
    dispatchApp({
      type: AppContextActions.UPDATE_TOP_NAVIGATION_BACKGROUND,
      value: TOP_NAVIGATION_BACKGROUND_TYPES.DEFAULT,
    });
    SoundManager.playSuccessSound();
  };

  const showErrorAlert = (message, destination) => {
    dispatchApp({
      type: AppContextActions.SHOW_ERROR_ALERT,
      value: { message, destination },
    });
    dispatchApp({
      type: AppContextActions.UPDATE_TOP_NAVIGATION_BACKGROUND,
      value: TOP_NAVIGATION_BACKGROUND_TYPES.ERROR,
    });
    SoundManager.playErrorSound();
  };

  const setPendingSuccessAlert = (message, destination) => {
    dispatchApp({
      type: AppContextActions.SET_PENDING_SUCCESS_ALERT,
      value: { message, destination },
    });
  };

  const setPendingErrorAlert = (message, destination) => {
    dispatchApp({
      type: AppContextActions.SET_PENDING_ERROR_ALERT,
      value: { message, destination },
    });
  };

  const showPendingAlert = () => {
    dispatchApp({ type: AppContextActions.SHOW_PENDING_ALERT });
    if (appState.alertOptions.type === APP_TOAST_TYPES.SUCCESS) {
      dispatchApp({
        type: AppContextActions.UPDATE_TOP_NAVIGATION_BACKGROUND,
        value: TOP_NAVIGATION_BACKGROUND_TYPES.DEFAULT,
      });
      SoundManager.playSuccessSound();
    } else {
      dispatchApp({
        type: AppContextActions.UPDATE_TOP_NAVIGATION_BACKGROUND,
        value: TOP_NAVIGATION_BACKGROUND_TYPES.ERROR,
      });
      SoundManager.playErrorSound();
    }
  };

  const hideAlert = () => {
    dispatchApp({ type: AppContextActions.HIDE_ALERT });
    dispatchApp({
      type: AppContextActions.UPDATE_TOP_NAVIGATION_BACKGROUND,
      value: TOP_NAVIGATION_BACKGROUND_TYPES.DEFAULT,
    });
  };

  return (
    <AppContext.Provider
      value={{
        appState,
        formatMessage,
        appActions: {
          updateTitle,
          openHelp,
          closeHelp,
          updateHelpOptionsList,
          clearHelpOptionsList,
          onBackPressed,
          openBackOptions,
          closeBackOptions,
          showLoader,
          hideLoader,
          showSuccessAlert,
          showErrorAlert,
          setPendingErrorAlert,
          setPendingSuccessAlert,
          showPendingAlert,
          hideAlert,
        },
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default injectIntl(AppContextProvider);
